import { useContext } from "react"
import { DialogFormContext } from "../contexts/DialogForm"

export default function useFormDialog() {
  return useContext(DialogFormContext)
}